export const WIRING_INSTRUCTIONS_SWISS = [
  {
    currency: 'EUR',
    fields: [
      {
        name: 'donate.bank.name',
        value: 'Wise',
      },
      {
        name: 'donate.bank.address',
        value: 'Avenue Louise 54, Room S52, Brussels 1050 Belgium',
      },
      {
        name: 'donate.account.holder',
        value: 'TrustBridge Global Foundation',
      },
      {
        name: 'donate.bank.swift.bic',
        value: 'TRWIBEB1XXX',
      },
      {
        name: 'donate.iban',
        value: 'BE71 9671 0973 6769',
      },
      {
        name: 'donate.account.number',
        value: '1097367',
      },
      {
        name: 'donate.account.address',
        value: 'Zelglistrasse 10, 3608 Thun, Switzerland',
      },
      {
        name: '_no_label_',
        value: 'If you are giving in EUR from outside the Euro SEPA zone, please also use the following intermediary bank information to ensure that your contribution will not be returned:',
      },
      {
        name: 'donate.recipient.swift.bic',
        value: 'TRWIBEB1XXX',
      },
      {
        name: 'donate.correspondent.swift.bic',
        value: 'TRWIGB2LXXX',
      },
    ],
  },
  {
    currency: 'GBP',
    fields: [
      {
        name: 'donate.bank.name',
        value: 'Wise',
      },
      {
        name: 'donate.account.holder',
        value: 'TrustBridge Global Foundation',
      },
      {
        name: 'donate.account.address',
        value: 'Zelglistrase  10, 3608 Thun, CH',
      },
      {
        name: 'donate.sort.code',
        value: '23-14-70',
      },
      {
        name: 'donate.account.number',
        value: '79172055',
      },
      {
        name: 'donate.iban',
        value: 'GB61 TRWI 2314 7079 1720 55',
      },
      {
        name: 'donate.bank.address',
        value: '56 Shoreditch High Street, London, E1 6JJ United Kingdom',
      },
    ],
  },
  {
    currency: 'CAD',
    fields: [
      {
        name: 'donate.account.holder',
        value: 'TrustBridge Global Foundation',
      },
      {
        name: 'donate.institution.number',
        value: '621',
      },
      {
        name: 'donate.account.number',
        value: '200110173566',
      },
      {
        name: 'donate.transit.number',
        value: '16001',
      },
      {
        name: 'donate.bank.name',
        value: 'Wise',
      },
      {
        name: 'donate.bank.address',
        value: '99 Bank Street, Suite 1420, Ottawa ON K1P 1H4, Canada',
      },
      {
        name: 'donate.account.address',
        value: 'Zelglistrasse 10, 3608 Thun, Switzerland',
      },
      {
        name: 'donate.note',
        value:
          'Domestic wire transfers, Interac, and Online Bill Transfers (OBTs) are not yet supported. Incoming payments take 1-2 working days to be added to your account',
      },
    ],
  },
  {
    currency: 'USD',
    instructionsSets: [
      [
        {
          name: 'donate.bank.name',
          value: 'Wise',
        },
        {
          name: 'donate.bank.address',
          value: '30 W. 26th Street, Sixth Floor New York NY 10010, United States',
        },
        {
          name: 'donate.account.name',
          value: 'TrustBridge Global Foundation',
        },
        {
          name: 'donate.account.address',
          value: 'Zelglistrasse 10 3608 Thun, Switzerland',
        },
        {
          name: 'donate.wire.routing.number',
          value: '026073150',
        },
        {
          name: 'donate.bank.swift.bic',
          value: 'CMFGUS33',
        },
        {
          name: 'donate.account.number',
          value: '8310265949',
        },
        {
          name: 'donate.note',
          value:
            'You might see Community Federal Savings Bank show up as the bank name. That is OK – the payment will still work.',
        },
      ],
    ],
    bankName: 'UBS AG',
    address: 'Bahnhofstrasse 45, 8098 Zurich, Switzerland',
    accountName: 'TrustBridge Global Foundation',
    swift: 'UBSWCHZH80A',
    iban: 'CH46 0020 6206 4859 1960 A',
    accountNumber: '0206 00485919.60A',
    accountAddress: 'Zelglistrasse 10, 3608 Thun, Switzerland',
  },
  {
    currency: 'CHF',
    taxDeduction: true,
    fields: [
      {
        name: 'donate.bank.name',
        value: 'UBS AG',
      },
      {
        name: 'donate.bank.address',
        value: 'Bahnhofstrasse 45, 8098 Zurich, Switzerland',
      },
      {
        name: 'donate.account.holder',
        value: 'TrustBridge Global Foundation',
      },
      {
        name: 'donate.bank.swift.bic',
        value: 'UBSWCHZH80A',
      },
      {
        name: 'donate.iban',
        value: 'CH23 0020 6206 4859 1901 J',
      },
      {
        name: 'donate.account.number',
        value: '0206 00485919.01J',
      },
      {
        name: 'donate.account.address',
        value: 'Zelglistrasse 10, 3608 Thun, Switzerland',
      },
    ],
  },
  {
    currency: 'CHF',
    taxDeduction: false,
    fields: [
      {
        name: 'donate.bank.name',
        value: 'UBS AG',
      },
      {
        name: 'donate.bank.address',
        value: 'Bahnhofstrasse 45, 8098 Zurich, Switzerland',
      },
      {
        name: 'donate.account.holder',
        value: 'TrustBridge Global Foundation',
      },
      {
        name: 'donate.bank.swift.bic',
        value: 'UBSWCHZH80A',
      },
      {
        name: 'donate.iban',
        value: 'CH33 0020 6206 4859 1902 U',
      },
      {
        name: 'donate.account.number',
        value: '0206 00485919.02U',
      },
      {
        name: 'donate.account.address',
        value: 'Zelglistrasse 10, 3608 Thun, Switzerland',
      },
    ],
  },
  {
    currency: 'AUD',
    fields: [
      {
        name: 'donate.bank.name',
        value: 'Wise',
      },
      {
        name: 'donate.bank.address',
        value: 'Suite 1, Level 11, 66 Goulburn Street Sydney 2000 Australia',
      },
      {
        name: 'donate.account.holder',
        value: 'TrustBridge Global Foundation',
      },
      {
        name: 'donate.account.number',
        value: '206106978',
      },
      {
        name: 'donate.account.address',
        value: 'Zelglistrasse 10, 3608 Thun, Switzerland',
      },
      {
        name: 'donate.bsb.code',
        value: '774001',
      },
    ],
  },
  {
    currency: 'BRL',
    fields: [
      {
        name: 'donate.bank.name',
        value: 'Crown Agents Bank',
      },
      {
        name: 'donate.account.holder',
        value: 'TrustBridge Global Foundation',
      },
      {
        name: 'donate.account.number',
        value: '34431090',
      },
      {
        name: 'donate.account.address',
        value: 'Zelglistrasse 10, 3608 Thun, Switzerland',
      },
      {
        name: 'donate.iban',
        value: 'GB89CRAS60836834431090',
      },
      {
        name: 'donate.sort.code',
        value: '608368',
      },
      {
        name: 'donate.bank.bic',
        value: 'CRASGB2L',
      },
    ],
  },
];

export const WIRING_INSTRUCTIONS_NEW_ZEALAND = [
  {
    currency: 'NZD',
    fields: [
      {
        name: 'donate.bank.name',
        value: 'Wise',
      },
      {
        name: 'donate.bank.address',
        value: '56 Shoreditch High Street, London, E1 6JJ, UK',
      },
      {
        name: 'donate.account.holder',
        value: 'TrustBridge Global Foundation',
      },
      {
        name: 'donate.account.number',
        value: '02-1290-0655287-000',
      },
      {
        name: 'donate.account.address',
        value: 'Zelglistrasse 10, 3608 Thun, Switzerland',
      },
    ],
  },
];

export const WIRING_INSTRUCTIONS_AUSTRALIA = [
  {
    currency: 'AUD',
    fields: [
      {
        name: 'donate.bank.name',
        value: 'Wise',
      },
      {
        name: 'donate.bank.address',
        value: 'Suite 1, Level 11, 66 Goulburn Street Sydney 2000 Australia',
      },
      {
        name: 'donate.account.holder',
        value: 'TrustBridge Global Foundation',
      },
      {
        name: 'donate.account.number',
        value: '206106978',
      },
      {
        name: 'donate.account.address',
        value: 'Zelglistrasse 10, 3608 Thun, Switzerland',
      },
      {
        name: 'donate.bsb.code',
        value: '774001',
      },
    ],
  },
];

export const WIRING_INSTRUCTIONS_CNCF = [
  {
    currency: 'CAD',
    fields: [
      {
        name: 'donate.bank.name',
        value: 'Bank of Nova Scotia',
      },
      {
        name: 'donate.bank.address',
        value:
          '44 King Street West, Toronto, ON, M5H 1H1 (Swift code), or PO Box 4234 Stn A, Toronto, ON, M5W 5P6 (Clearing code)',
      },
      {
        name: 'donate.bank.swift',
        value: 'NOSCATT',
      },
      {
        name: 'donate.clearing.code',
        value: 'CC0002 47886',
      },
      {
        name: 'donate.account.holder',
        value: 'Canadian National Christian Foundation',
      },
      {
        name: 'donate.account.number',
        value: '00166 00602 16',
      },
      {
        name: 'donate.account.address',
        value: '89 Auriga Drive, Ottawa, ON K2E 7Z2',
      },
    ],
  },
];

export const WIRING_INSTRUCTIONS_EME = [
  {
    currency: 'AUD',
    fields: [
      {
        name: 'donate.bank.name',
        value: 'Australia New Zealand Bank (ANZ)',
      },
      {
        name: 'donate.bank.address',
        value: '10 Main Street, Box Hill, Australia, 3128',
      },
      {
        name: 'donate.account.holder',
        value: 'M E Foundation for Aid and Relief',
      },
      {
        name: 'donate.bank.swift.bic',
        value: 'ANZBAU3M',
      },
      {
        name: 'donate.account.number',
        value: '013225460261674',
      },
    ],
  },
];

export const WIRING_INSTRUCTIONS_IGF = [
  {
    currency: 'USD',
    fields: [
      {
        name: 'donate.routing.number',
        value: '061100606',
      },
      {
        name: 'donate.account.number',
        value: '1016761775',
      },
      {
        name: 'donate.bank.name',
        value: 'Synovus Bank',
      },
      {
        name: 'donate.account.name',
        value: 'International Generosity Foundation Trust',
      },
      {
        name: 'donate.receiving.bank.address',
        value: '1148 Broadway, Columbus, GA 31901',
      },
    ],
  },
];

export const WIRING_INSTRUCTIONS_GLF = [
  {
    currency: 'USD',
    fields: [
      {
        name: 'donate.bank.name',
        value: 'Wise',
      },
      {
        name: 'donate.bank.address',
        value: '30 W. 26th Street, Sixth Floor New York NY 10010, United States',
      },
      {
        name: 'donate.account.holder',
        value: 'GIVERS LEGACY FOUNDATION, INC.',
      },
      {
        name: 'donate.account.address',
        value: '1901 Ulmerton Road, Suite 400, Clearwater, FL 33762',
      },
      {
        name: 'donate.ach.wire.routing.number',
        value: '026073150',
      },
      {
        name: 'donate.account.number',
        value: '822000080496',
      },
      {
        name: 'donate.account.type',
        value: 'Checking',
      },
      {
        name: 'donate.note',
        value:
          'You might see Community Federal Savings Bank show up as the bank name. That is OK – the payment will still work.',
      },
    ],
  },
];

export const WIRING_INSTRUCTIONS_SINNGEBER = [
  {
    currency: 'EUR',
    fields: [
      {
        name: 'donate.account.holder',
        value: 'Hoffnungsträger Stiftung',
      },
      {
        name: 'donate.iban',
        value: 'DE97600400710530590900',
      },
      {
        name: 'donate.bic',
        value: 'COBADEFFXXX',
      },
      {
        name: 'donate.bank.name',
        value: 'Commerzbank Stuttgart',
      },
    ],
  },
];

export const WIRING_INSTRUCTIONS_TOL = [
  // Tax Ded = YES
  {
    currency: 'ZAR',
    fields: [
      {
        name: 'donate.bank.name',
        value: 'RMB Private Bank',
      },
      {
        name: 'donate.branch.name',
        value: 'Stellenbosch',
      },
      {
        name: 'donate.bank.address',
        value: '43 Plein Street, Stellenbosch, 7600',
      },
      {
        name: 'donate.account.holder',
        value: 'True South Foundation Trust',
      },
      {
        name: 'donate.branch.code',
        value: '250408',
      },
      {
        name: 'donate.account.number',
        value: '62644363161',
      },
      {
        name: 'donate.bank.swift',
        value: 'FIRNZAJJ',
      },
      {
        name: 'donate.account.address',
        value: 'Unit F12 Willowbridge Centre, 39 Carl Cronjé Drive, Bellville, 7530',
      },
    ],
  },
  // Tax Ded = NO
  {
    currency: 'ZAR',
    fields: [
      {
        name: 'donate.bank.name',
        value: 'RMB Private Bank',
      },
      {
        name: 'donate.branch.name',
        value: 'Stellenbosch',
      },
      {
        name: 'donate.bank.address',
        value: '43 Plein Street, Stellenbosch, 7600',
      },
      {
        name: 'donate.account.holder',
        value: 'Tree of Life Foundation',
      },
      {
        name: 'donate.branch.code',
        value: '250408',
      },
      {
        name: 'donate.account.number',
        value: '62295708708',
      },
      {
        name: 'donate.bank.swift',
        value: 'FIRNZAJJ',
      },
      {
        name: 'donate.account.address',
        value: 'Unit F12 Willowbridge Centre, 39 Carl Cronjé Drive, Bellville, 7530',
      },
    ],
  },
];

export const WIRING_INSTRUCTIONS_GAUDIUM = [
  {
    currency: 'USD',
    fields: [
      {
        name: 'donate.bank.name',
        value: 'Banco Popular de Puerto Rico',
      },
      {
        name: 'donate.branch.name',
        value: 'San Juan',
      },
      {
        name: 'donate.bank.address',
        value: '206 C. Tetuán, San Juan, 00901',
      },
      {
        name: 'donate.account.holder',
        value: 'Gaudium et Spes Foundation Inc',
      },
      {
        name: 'donate.branch.code',
        value: 'San Juan Los Puertos 396',
      },
      {
        name: 'donate.account.number',
        value: '396-074030',
      },
      {
        name: 'donate.bank.swift',
        value: 'BPPRPRSXXXX',
      },
      {
        name: 'donate.account.address',
        value: 'Miramar Plaza, 954 Ave Ponce de Leon, STE 602, San Juan, PR 00907',
      },
    ],
  },
];

export const EFT_INSTRUCTIONS_CNCF = {
  bankName: '002',
  transit: '00166',
  accountNumber: '0060216',
};

export const EFT_INSTRUCTIONS_IGF = {
  bankName: 'Synovus Bank',
  accountName: 'International Generosity Foundation',
  foundation: '',
  routingNumber: '061100606',
  accountNumber: '1016761775',
};

export const EFT_INSTRUCTIONS_GLF = {
  bankName: 'UMB Bank, N.A.',
  accountName: 'Givers Legacy Foundation, Inc.',
  currency: 'USD',
  foundation: 'Givers Legacy Foundation',
  routingNumber: '044000804',
  accountNumber: '8200453111',
};

export const WIRING_INSTRUCTIONS_SWISS_TAX_DED_NO = {
  currency: 'CHF',
  fields: [
    {
      name: 'donate.bank.name',
      value: 'UBS AG',
    },
    {
      name: 'donate.bank.address',
      value: 'Bahnhofstrasse 45, 8098 Zurich, Switzerland',
    },
    {
      name: 'donate.account.holder',
      value: 'TrustBridge Global Foundation',
    },
    {
      name: 'donate.bank.swift.bic',
      value: 'UBSWCHZH80A',
    },
    {
      name: 'donate.iban',
      value: 'CH33 0020 6206 4859 1902 U',
    },
    {
      name: 'donate.account.number',
      value: '0206 00485919.02U',
    },
    {
      name: 'donate.account.address',
      value: 'Zelglistrasse 10, 3608 Thun, Switzerland',
    },
  ],
};

export const WIRING_INSTRUCTIONS_FONTE = [
  {
    currency: 'R$ Real',
    fields: [
      {
        name: 'donate.bank.name',
        value: 'SC XP investimentos',
      },
      {
        name: 'donate.branch.name',
        value: '0001',
      },
      {
        name: 'donate.bank.number',
        value: '102',
      },
      {
        name: 'donate.account.holder',
        value: 'gestora do fundo patrimonial fonte',
      },
      {
        name: 'donate.branch.code',
        value: '1672433',
      },
      {
        name: 'donate.account.number',
        value: '5',
      },
      {
        name: 'donate.bank.swift',
        value: 'BCXPBRSP',
      },
      {
        name: 'donate.account.address',
        value: 'Q SGAS 910 CONJUNTO B BLOCO I SALA 16 ASA SUL BRASILIA',
      },
      {
        name: 'donate.zip.code',
        value: '70.390-100',
      },
    ],
  },
];

export const WIRING_INSTRUCTIONS_RHEMA = [
  {
    currency: 'CAD',
    fields: [
      {
        name: 'donate.account.holder',
        value: 'TrustBridge Global Foundation',
      },
      {
        name: 'donate.institution.number',
        value: '621',
      },
      {
        name: 'donate.account.number',
        value: '200110173566',
      },
      {
        name: 'donate.transit.number',
        value: '16001',
      },
      {
        name: 'donate.bank.name',
        value: 'Wise',
      },
      {
        name: 'donate.bank.address',
        value: '99 Bank Street, Suite 1420, Ottawa ON K1P 1H4, Canada',
      },
      {
        name: 'donate.account.address',
        value: 'Zelglistrasse 10, 3608 Thun, Switzerland',
      },
      {
        name: 'donate.note',
        value:
          'Domestic wire transfers, Interac, and Online Bill Transfers (OBTs) are not yet supported. Incoming payments take 1-2 working days to be added to your account',
      },
    ],
  },
  {
    currency: 'EUR',
    fields: [
      {
        name: 'donate.bank.name',
        value: 'Wise',
      },
      {
        name: 'donate.bank.address',
        value: 'Avenue Louise 54, Room S52, Brussels 1050 Belgium',
      },
      {
        name: 'donate.account.holder',
        value: 'TrustBridge Global Foundation',
      },
      {
        name: 'donate.bank.swift.bic',
        value: 'TRWIBEB1XXX',
      },
      {
        name: 'donate.iban',
        value: 'BE71 9671 0973 6769',
      },
      {
        name: 'donate.account.number',
        value: '1097367',
      },
      {
        name: 'donate.account.address',
        value: 'Zelglistrasse 10, 3608 Thun, Switzerland',
      },
      {
        name: 'donate.note',
        value:
          'Domestic wire transfers, Interac, and Online Bill Transfers (OBTs) are not yet supported. Incoming payments take 1-2 working days to be added to your account',
      },
      {
        name: '_no_label_',
        value: 'If you are giving in EUR from outside the Euro SEPA zone, please also use the following intermediary bank information to ensure that your contribution will not be returned:',
      },
      {
        name: 'donate.recipient.swift.bic',
        value: 'TRWIBEB1XXX',
      },
      {
        name: 'donate.correspondent.swift.bic',
        value: 'TRWIGB2LXXX',
      },
    ],
  },
  {
    currency: 'GBP',
    fields: [
      {
        name: 'donate.bank.name',
        value: 'Wise',
      },
      {
        name: 'donate.account.holder',
        value: 'TrustBridge Global Foundation',
      },
      {
        name: 'donate.account.address',
        value: 'Zelglistrase 10, 3608 Thun, CH',
      },
      {
        name: 'donate.sort.code',
        value: '23-14-70',
      },
      {
        name: 'donate.account.number',
        value: '79172055',
      },
      {
        name: 'donate.iban',
        value: 'GB61 TRWI 2314 7079 1720 55',
      },
      {
        name: 'donate.bank.address',
        value: '56 Shoreditch High Street, London, E1 6JJ United Kingdom',
      },
    ],
  },
  {
    currency: 'USD',
    fields: [
      {
        name: 'donate.bank.name',
        value: 'Wise',
      },
      {
        name: 'donate.bank.address',
        value: '30 W. 26th Street, Sixth Floor New York NY 10010, United States',
      },
      {
        name: 'donate.account.name',
        value: 'TrustBridge Global Foundation',
      },
      {
        name: 'donate.account.holder',
        value: 'Zelglistrasse 10 3608 Thun, Switzerland',
      },
      {
        name: 'donate.wire.routing.number',
        value: '026073150',
      },
      {
        name: 'donate.bank.swift.bic',
        value: 'CMFGUS33',
      },
      {
        name: 'donate.account.number',
        value: '8310265949',
      },
      {
        name: 'donate.note',
        value:
          'You might see Community Federal Savings Bank show up as the bank name. That is OK – the payment will still work.',
      },
    ],
  },
];
